import React, { forwardRef } from 'react';
import { getContext } from 'common';

import Elevation from 'components/Elevation';
import { SPACING_8 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';
import { RADIUS_2 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/border-radius';

const GET_STYLE = RTL => RTL ? ({
  display: 'flex',
  maxWidth: 'fit-content',
  width: '-moz-fit-content',
  cursor: 'pointer',
  marginLeft: SPACING_8,
  borderRadius: RADIUS_2,
  background: 'transparent'
}) : ({
  display: 'flex',
  maxWidth: 'fit-content',
  width: '-moz-fit-content',
  cursor: 'pointer',
  marginRight: SPACING_8,
  borderRadius: RADIUS_2,
  overflow: 'hidden',
  background: 'transparent'
});

export interface SearchwChipsGlobalLogicProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of SearchwChipsGlobalLogicProps, consider using SearchwChipsGlobalLogicButton */
  children: React.ReactNode,
  /** To override the SearchwChipsGlobalLogic theme please refer to "Readme" tab to learn more. */
  theme?: any;
}

/**
 * <SearchwChipsGlobalLogic/> extend `Elevation` with customized style to make global 'AND' or 'OR' for `SearchwChips`.
 * All `Elevation` props are available through this component. Refer to `Elevation`'s documentation for more information.
 */
const SearchwChipsGlobalLogic = forwardRef<HTMLElement, SearchwChipsGlobalLogicProps>((props: SearchwChipsGlobalLogicProps, ref) => getContext(({ RTL }) => {
  const {
    children,
    theme: themeProp,
    ...otherProps
  } = props;
  return (
    <Elevation
      elevationIndex={1}
      style={GET_STYLE(RTL)}
      theme={themeProp}
      ref={ref}
      {...otherProps}
    >
      {children}
    </Elevation>);
}));

SearchwChipsGlobalLogic.defaultProps = {
  theme: {}
};
SearchwChipsGlobalLogic.displayName = 'SearchwChipsGlobalLogic';
export default SearchwChipsGlobalLogic;
